import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ButtonBase, CircularProgress } from "@material-ui/core";
import styles from "./Style.module.css";
import useZoneDashboard from "./ZoneDashboard.hook";
import CustomDatePicker from "../../../components/FormFields/DatePicker/CustomDatePicker";
import PageBoxComponent from "../../../components/PageBox/PageBox.component";
import ZoneStatus from "./component/ZoneStatus/ZoneStatus";

const ZoneDashboard = ({ location }) => {
  const {
    initialApiCall,
    startDate,
    endDate,
    handleChangeDate,
    startValid,
    endValid,
    apiData,
    isSubmitting,
  } = useZoneDashboard({ location });

  const renderStartDate = useMemo(() => {
    return (
      <CustomDatePicker
        clearable
        label={"Start Date"}
        maxDate={new Date()}
        onChange={(value) => {
          handleChangeDate(value, "start");
        }}
        value={startDate}
        isError={startValid}
      />
    );
  }, [startDate, startValid]);

  const renderEndDate = useMemo(() => {
    return (
      <CustomDatePicker
        clearable
        label={"End Date"}
        // maxDate={new Date()}
        onChange={(value) => {
          handleChangeDate(value, "end");
        }}
        value={endDate}
        isError={endValid}
      />
    );
  }, [endDate, endValid]);

  return (
    <div>
      <PageBoxComponent>
        <div className={styles.headerContainer}>
          <div>
            <span className={styles.title}>Zone Comparison Dashboard</span>
            <div className={styles.newLine} />
          </div>
        </div>

        <div className={styles.yearFlex}>
          <div className={styles.UpperWrap}>
            <div className={styles.down}>{renderStartDate}</div>
            <div className={styles.down}>{renderEndDate}</div>
          </div>
        </div>
          <div className={styles.note}>Disclaimer: Regional classification before 1st April 2025 is not actual reflection of regions.</div>
      </PageBoxComponent>
      <br />
      {isSubmitting ? (
        <div className={styles.loaderWrap}>
          <CircularProgress color="success" size="20px" />
        </div>
      ) : (
        <div className={styles.zoneWrapper}>
          {apiData?.map((val, index) => {
            return (
              <div key={`zones_${index}`}>
                <ZoneStatus zoneData={val} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ZoneDashboard;
